/**
 * @returns Money or an empty object if price is undefined.
 */

export const getPlanPrice = plan => {
  var _plan$pricing$price, _plan$pricing;
  return (_plan$pricing$price = plan == null ? void 0 : (_plan$pricing = plan.pricing) == null ? void 0 : _plan$pricing.price) != null ? _plan$pricing$price : {};
};
//# sourceMappingURL=get-plan-price.js.map